import { SvgIcon } from "@mui/material";

export default function RectangleIcon(props) {
  return (
    <SvgIcon sx={{height:"7px"}} {...props}>
      <rect x="5"  width="70" height="10"/>
    </SvgIcon>
  );
}

